import axiosInstance from '../app/axios';

export const createServiceTypeFileApi = async (formData: any) => {
  const result = await axiosInstance.post("files/upload/servicetype", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return result.data;
};

export const createAdminFileApi = async (formData: any) => {
  const result = await axiosInstance.post("files/upload/admin", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return result.data;
};
